<template>
  <div id="app">
    <Header />
    <main class="main-content">
      <router-view />
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';

export default {
  components: { Header, Footer },
};
</script>

<style>
/* Глобальные стили */
#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh; /* Минимальная высота экрана */

}

.main-content {
  display: flex;
  justify-content: center;
  flex: 1; /* Контент занимает оставшееся пространство */
  padding: 20px; /* Отступы для содержимого */
}
</style>
